<template>
	<div id="app">
		<transition name="fade"
		            mode="out-in">
			<router-view></router-view>
		</transition>
	</div>

</template>

<script>
import routeCache from './utils/routeCacheMiddleware'
export default {
	name: 'app',

  mounted() {
    this.$nextTick(() => {
      const cached = routeCache.get(this.$route)
      if (cached) {
        // 恢复滚动位置
        window.scrollTo(0, cached.scrollPosition || 0)
        // 提供缓存数据给页面组件
        this.$data.$pageData = cached
      }
    })
  }
}

</script>

<style lang="scss">
body {
	margin: 0px;
	padding: 0px;
	/*background: url(assets/bg1.jpg) center !important;
		background-size: cover;*/
	// background: #1F2D3D;
	font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
	font-size: 14px;
	-webkit-font-smoothing: antialiased;
}

#app {
	position: absolute;
	top: 0px;
	bottom: 0px;
	width: 100%;
}

.el-submenu [class^=fa] {
	vertical-align: baseline;
	margin-right: 10px;
}

.el-menu-item [class^=fa] {
	vertical-align: baseline;
	margin-right: 10px;
}

.toolbar {
	//background: #f2f2f2;
	padding: 5px;
	//border:1px solid #dfe6ec;
	margin: 5px 0px;

	.el-form-item {
		margin-bottom: 2px;
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: all .2s ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// App.vue?c8d40742